export function startAsyncRpaPanelTracking(run, { isAsyncRun, openPanel } = {}) {
  if (typeof isAsyncRun !== 'function' || !isAsyncRun(run)) return false

  if (typeof openPanel === 'function') openPanel()
  return true
}
